import { Link } from "react-router-dom";
import { ArrowRight, Sun, Repeat, Zap } from "lucide-react";

const POINTS = [
  { icon: Sun, title: "Solar panels generate electricity on your roof", desc: "Daytime production supplies your home first, with any excess exported to the utility grid." },
  { icon: Repeat, title: "Net metering tracks what you send and receive", desc: "Each qualifying kilowatt-hour you send out can offset a kilowatt-hour you pull back later, subject to utility rules." },
  { icon: Zap, title: "A Power Purchase Agreement (PPA) sets a predictable rate", desc: "You buy the clean energy the system produces — not the equipment — at a defined rate for the term of the agreement." },
];

export default function HowSolarPreview() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="how-solar-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <div className="eyebrow">How It Works</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C] leading-tight">
            The short version of solar + a PPA.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg">
            Three ideas that cover almost every homeowner question. The full version with timelines, net-metering rules, and the Solar 1.0–4.0 evolution lives on a separate page.
          </p>
          <Link
            to="/how-solar-works"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#B45309] hover:text-[#0F382C]"
            data-testid="how-solar-preview-link"
          >
            Read the full explanation <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-7 space-y-4">
          {POINTS.map((p, i) => (
            <div key={p.title} className="card-warm p-6 flex items-start gap-4">
              <div className="w-11 h-11 rounded-xl bg-[#D97706] flex items-center justify-center shrink-0">
                <p.icon className="w-5 h-5 text-[#FDFBF7]" />
              </div>
              <div>
                <div className="font-mono-metric text-[11px] tracking-widest text-[#B45309]">0{i + 1}</div>
                <h3 className="mt-1 font-serif-display text-lg text-[#0F382C] leading-snug">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
